module.exports = __webpack_public_path__ + "img/order_material_to_excel_style2.fbb6200d.png";